import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';

export const authGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const afAuth = inject(AngularFireAuth);

  const isNative = Capacitor.isNativePlatform();
  const isOnboardingRouteOrLogin = state.url === '/app-onboarding' || state.url === '/login';

  if (isNative) { 
    try {
      const result = await FirebaseAuthentication.getCurrentUser();
      console.log("holaaakaha", JSON.stringify(result));

      if (result?.user?.uid) {
        // ✅ Redirect to dashboard if already logged in and accessing onboarding
        return isOnboardingRouteOrLogin ? router.parseUrl('/dashboard') : true;
      } else {
        // Not logged in — allow onboarding, redirect from protected routes
        return isOnboardingRouteOrLogin ? true : router.parseUrl('/app-onboarding');
      }
    } catch (error) {
      console.error('Native auth check failed:', error);
      return isOnboardingRouteOrLogin ? true : router.parseUrl('/app-onboarding');
    }
  } else {
    const user = await new Promise<firebase.User | null>((resolve) => {
      const unsubscribe = afAuth.onAuthStateChanged(async (currentUser: any) => {
        (await unsubscribe)(); // Unsubscribe after receiving the user state
        resolve(currentUser);
      });
    });

    if (user?.uid) {
      return isOnboardingRouteOrLogin ? router.parseUrl('/dashboard') : true;
    } else {
      return isOnboardingRouteOrLogin ? true : router.parseUrl('/login');
    }
  }
};
